<template>
    <div>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button class="button_back" @click="goBack">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="pill next-pill-button" @click="save('userForm')" :disabled="formsData.userForm.disabled">
            <span>Save</span>
          </ion-button>
        </ion-buttons>
        <ion-title>My Profile</ion-title>
      </ion-toolbar>
  
      <div class="main_wrapper ion-padding">
        <div class="container">
          <el-form :model="formsData?.userForm" :rules="formsData?.userForm.rules"
            :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')"
            @keyup.enter="goNext('userForm')">
            <div class="settings_menu">
              <div class="menu_title">
                <span v-if="userRole == 'locum' || userRole === 'agency'">Personal Details</span>
                <span v-else>Business details</span>
              </div>
            </div>
            <!-- WORKING -->
            <div class="form_part">
              <template v-if="userRole == 'pharmacy'">
                <el-form-item label="Company/Employer Name" prop="name">
                  <el-input v-model="formsData.userForm.name.value" autocomplete="off" placeholder="Pharmacy Name"
                    :maxlength="75" @keyup="formsData.userForm.name.value = $event.target.value"
                    @input="checkFormValidation('userForm', true)"></el-input>
                </el-form-item>
              </template>
  
              <el-form-item label="Find Your Address" prop="address">
                <div class="el-input el-input--suffix">
                  <vue-google-autocomplete id="map" classname="el-input__inner"
                    :ref="(el) => (formsData.userForm.address.ref = el)" v-model="formsData.userForm.address.value.text"
                    placeholder="Please select your address" @placechanged="setAddressData"
                    @input="checkFormValidation('userForm', true)" @keyup="setAddress" :country="countryArray">
                  </vue-google-autocomplete>
                  <span class="el-input__suffix">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z"
                        stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
                      <path
                        d="M3.01675 7.07533C4.65842 -0.141339 15.3501 -0.133006 16.9834 7.08366C17.9418 11.317 15.3084 14.9003 13.0001 17.117C11.3251 18.7337 8.67508 18.7337 6.99175 17.117C4.69175 14.9003 2.05842 11.3087 3.01675 7.07533Z"
                        stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
                    </svg>
                  </span>
                </div>
              </el-form-item>
  
              <el-form-item v-if="userRole == 'pharmacy'" :label="shopLabel" prop="shop_number">
                <el-input @keyup="
                  formsData.userForm.shop_number.value = $event.target.value" :ref="(el) => (formsData.userForm.shop_number.ref = el)"
                  v-model="formsData.userForm.shop_number.value" :placeholder="shopLabel" >
                </el-input>
              </el-form-item>
  
             
            </div>
            <!-- !!!!!  -->
            <!-- WORKING -->
            <div class="form_part">
  
              <el-form-item label="Phone Number" prop="mobileNumber" :required="true"
                class="collapsing-dropdown-scroll-off">
                <div class="el-input">
                  <vue-tel-input class="el-input__inner" :value="formsData.userForm.mobileNumber.valueFormatted"
                    v-model="formsData.userForm.mobileNumber.value" @input="onPhoneInput" :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                    v-bind="{ mode: 'international' }"></vue-tel-input>
                </div>
              </el-form-item>
  
              <el-form-item label="Email" prop="email" :required="true">
                <el-input type="email" v-model="formsData.userForm.email.value" placeholder="email@gmail.com"
                  @input="checkFormValidation('userForm', true)"></el-input>
              </el-form-item>
  
  
            </div>
            
              <div class="form_part">
                  <div class="settings_menu">
                    <div class="menu_title">Additional Contacts</div>
                  </div>
              </div>
              <div class="form_part">
                <el-form-item label="Primary Contact" prop="additionalName1">
                  <el-input v-model="formsData.userForm.additionalName1.value" autocomplete="off" placeholder="Name"
                    :maxlength="20" @keyup="
                      formsData.userForm.additionalName1.value = $event.target.value
                      "></el-input>
                </el-form-item>
                <!-- <el-form-item label="Primary Contact’s Email Address" prop="additionalEmail1" :required="true">
                    <el-input
                    type="email"
                    v-model="formsData.userForm.additionalEmail1.value"
                    placeholder="email@gmail.com"
                    @blur="checkFormValidation('userForm', true, 'additionalEmail1')"
                    ></el-input>
                </el-form-item> -->
                <el-form-item label="Primary Contact's Phone Number" prop="additionalPhone1">
                  <div class="el-input">
                    <vue-tel-input class="el-input__inner" :value="formsData.userForm.additionalPhone1.valueFormatted"
                      v-model="formsData.userForm.additionalPhone1.value" :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                      v-bind="{ mode: 'international' }" @input="onPhoneInput1"></vue-tel-input>
                  </div>
                </el-form-item>
              </div>

              <div class="form_part" v-if="userRole === 'pharmacy' && userData.site.parentId === 2">
                  <div class="settings_menu">
                    <div class="menu_title">Additional Information</div>
                  </div>
                  <div class="form_part">
                    <el-form-item :label="pharmacyAdditionalInfo?.hospitalPharmacy1AdditionalInfo[0]?.label ? pharmacyAdditionalInfo?.hospitalPharmacy1AdditionalInfo[0]?.label : 'What Dispensary & Electronic Medication Management (EMM) Software do you use?'" prop="EMMSoftware" class="onboarding_form_checkbox">
                        <el-checkbox-group v-model="formsData.userForm.EMMSoftware.value">
                            <el-checkbox v-for="option in pharmacyAdditionalInfo?.hospitalPharmacy1AdditionalInfo[0]?.values || []" :key="option.label" 
                                :label="option.label">
                                {{ option.label }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item :label="pharmacyAdditionalInfo?.hospitalPharmacy2AdditionalInfo[0]?.label ? pharmacyAdditionalInfo?.hospitalPharmacy2AdditionalInfo[0]?.label : 'Which Automated Dispensing Cabinets (ADC) do you use?'" prop="automatedDispenseryCabinet"
                        class="onboarding_form_checkbox">
                        <el-select popper-class="normal-select" class="w-100"
                            v-model="formsData.userForm.automatedDispenseryCabinet.value"
                            placeholder="Select Automated Dispensery Cabinet" :popper-append-to-body="true">
                            <el-option v-for="option in pharmacyAdditionalInfo?.hospitalPharmacy2AdditionalInfo[0]?.values || []" :key="option.label"
                                :label="option.label" :value="option.label"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
              </div>
             
              <div class="form_part">
                <div class="settings_menu">
                  <div class="menu_title">Settings</div>
                </div>
                <div class="settings_menu">
                  <el-button type="transparent" class="menu_item" @click="links.changePassword">
                    <!-- <span class="locumate_icons el-icon-set-up"></span> -->
                    <img src="@/assets/img/icons/key-square.svg" alt="Gallery">
                    <div class="text_wrapper">
                      <div class="main_text">Password Change</div>
                    </div>
                  </el-button>
                </div>
              </div>
          </el-form>
        </div>
  
        <div class="bg-overlay"></div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    onMounted,
    inject,
    defineAsyncComponent,
    nextTick,
    computed,
    getCurrentInstance
  } from "vue";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  // import moment from "moment";
  
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
  } from "@ionic/vue";
  
  import { useStore } from "vuex";
  import { useRouter, onBeforeRouteLeave } from "vue-router";
  import formHooks from "@/hooks/form/form";
  import formValidate from "@/hooks/form/validate/validate";
  import IMaskDirective from "@/directives/vue-imask/directive";
  import addressText from "@/helpers/address/address.js";
  import { VueGoogleAutocomplete } from "@/components/components";
  import { ElMessageBox } from "@/components/Vendor/Element";
  import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
  
  
  const VueTelInput = defineAsyncComponent(() =>
    import("@/components/Vendor/vue-tel-input/components/vue-tel-input.vue")
  );
  
  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      IonTitle,
      VueGoogleAutocomplete,
      VueTelInput,
    },
    directives: {
      imask: IMaskDirective,
    },
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const setPageClassGlobal = inject(["setPageClassGlobal"]);
      const googleMaps = inject(["googleMaps"]);
      const $moment = inject(["$moment"]);
      const userData = $store.getters.GET_USER_DATA;
      const pharmacyAdditionalInfo = $store.getters.pharmacyAdditionalInfo;
      const userRole = userData.role;
      const email = userData.email;
      const isAustralia = isAustraliaRegion();
      const isUS = isUSRegion();
      const instance = getCurrentInstance();
      const isHealthPlanEnabled = false;
     
  
      const countryArray = computed(() => {
        const region = process.env.VUE_APP_REGION;
        if (region === 'US') return ['us'];
        if (region === 'AU') return ['au'];
        return []; // Default or empty if region is not recognized
      });
      
     
  
  
    
      const dateConvert = () => {
        if (formsData.userForm.ahpraExpiryDate.valueFormatted) {
          const result = $moment(
            formsData.userForm.ahpraExpiryDate.valueFormatted,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
          formsData.userForm.ahpraExpiryDate.value = result;
          checkFormValidation("userForm", false);
        } else {
          formsData.userForm.ahpraExpiryDate.value = null;
          return null;
        }
      };
  
     
        
      const formsDataArray = {
        userForm: {
          address: {
            value: {
              text: addressText(userData.address ? userData.address : ""),
              temp: addressText(userData.address ? userData.address : ""),
            },
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "address",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
  
          mobileNumber: {
            ref: {},
            value: userData.mobileNumber ? userData.mobileNumber : "",
            valueFormatted: userData.mobileNumber ? userData.mobileNumber : "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "mobileNumber",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
            errors: null,
          },
          email: {
            value: email ? email : "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "email",
                    callback,
                    setFormValidation
                  );
                },
                trigger: ["blur", "enter"],
              },
            ],
          },
        },
      };
     
  
      if (userRole == "pharmacy") {
       
  
        const dataArray = {
          name: {
            value: userData.name || "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "pharmacyName",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
          shop_number: {
            value: userData.address.shopNumber || "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "shopNumber",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
          additionalName1: {
            value: userData.additionalName1 || "",
  
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "additionalName1",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
          additionalPhone1: {
            ref: {},
            value: userData.additionalPhone1 || null,
            valueFormatted: userData.additionalPhone1 || null,
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "additionalPhone1",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
            errors: null,
          },
          additionalEmail1: {
          value: userData.additionalEmail1 || null,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "additionalEmail1",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
        EMMSoftware: {
            value: (userData.customFields?.hospitalPharmacy1AdditionalInfo ?? []).map((item) => item.value),
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "alwaysTrue",
                    callback,
                    setFormValidation
                  );
                },
                trigger: ["change"],
              },
            ]
        },
        automatedDispenseryCabinet: {
            value: userData.customFields?.hospitalPharmacy2AdditionalInfo?.[0]?.value ?? "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "alwaysTrue",
                    callback,
                    setFormValidation
                  );
                },
                trigger: ["change"],
              },
            ]
        },
         
        };
  
        Object.assign(formsDataArray.userForm, dataArray);
      }
  
  
     
      const onPhoneInput1 = (value, phoneObject) => {
        console.log("EHERE IS TEH PHONE 1");
        if (!value.target) {
          formsData.userForm.additionalPhone1.ref.phoneObject = phoneObject;
        }
        formsData.userForm.additionalPhone1.valueFormatted = value.target
          ? value.target.value
          : value;
        formsData.userForm.additionalPhone1.value =
          formsData.userForm.additionalPhone1.ref.phoneObject.number || null;
  
        checkFormValidation("userForm", false, "additionalPhone1");
        checkFormValidation("userForm", true);
      };
      
  
      const onPhoneInput = (value, phoneObject) => {
        if (!value.target) {
          formsData.userForm.mobileNumber.ref.phoneObject = phoneObject;
        }
        formsData.userForm.mobileNumber.valueFormatted = value.target
          ? value.target.value
          : value;
        formsData.userForm.mobileNumber.value =
          formsData.userForm.mobileNumber.ref.phoneObject.number || null;
  
        checkFormValidation("userForm", false, "mobileNumber");
        checkFormValidation("userForm", true);
      };
  
     
      const setAddress = () => {
        if (
          formsData.userForm.address.value.text !=
          formsData.userForm.address.value.temp
        ) {
          formsData.userForm.address.value.text = null;
        }
        checkFormValidation("userForm", true, "address");
        checkFormValidation("userForm", true);
      };
     
  
      const setAddressData = async (addressData, placeResultData) => {
        try {
          formsData.userForm.address.value.lat = addressData.latitude.toString();
          formsData.userForm.address.value.lng = addressData.longitude.toString();
          formsData.userForm.address.value.subpremise = addressData.subpremise
            ? addressData.subpremise
            : "";
          formsData.userForm.address.value.street =
            (formsData.userForm.address.value.subpremise
              ? formsData.userForm.address.value.subpremise + "/"
              : "") +
            (addressData.street_number ? addressData.street_number + " " : "") +
            addressData.route;
  
          formsData.userForm.address.value.state =
            addressData.administrative_area_level_1
              ? addressData.administrative_area_level_1
              : "";
          formsData.userForm.address.value.suburb = addressData.locality
            ? addressData.locality
            : "";
          formsData.userForm.address.value.country = addressData.country
            ? addressData.country
            : "";
          formsData.userForm.address.value.postcode = addressData.postal_code
            ? addressData.postal_code
            : "";
  
          console.log("placeResultData", placeResultData.formatted_address);
          formsData.userForm.address.value.text =
            placeResultData.formatted_address;
          formsData.userForm.address.value.temp =
            placeResultData.formatted_address;
          formsData.userForm.address.ref.update(
            formsData.userForm.address.value.text
          );
          const timezone = await googleMaps.getTimeZone(
            formsData.userForm.address.value.lat +
            "," +
            formsData.userForm.address.value.lng
          );
          formsData.userForm.address.value.timezone = timezone.timeZoneId;
        } catch (error) {
          console.log(error);
        }
        checkFormValidation("userForm", true);
      };
  
      const goBack = () => {
        $router.push({
          name: "my_profile",
        });
      };
  
      const getFormData = (formName) => {
        const result = Object.fromEntries(
          Object.entries(formsData[formName])
            .map(([k, v]) => [k, v?.value])
            .filter(([k, v]) => v !== undefined) // eslint-disable-line no-unused-vars
        );
        if (result.abn) {
          result.abn = result.abn.replaceAll(" ", "");
        }
       
        return result;
      };
  
      const save = (formName) => {
        console.log("formName", formName);
        formsRefs[formName].value.validate((valid) => {
          if (valid) {
            return (async () => {
              try {
                if (
                  (formsData[formName].firstName &&
                    formsData[formName].firstName.fieldChanged) ||
                  (formsData[formName].lastName &&
                    formsData[formName].lastName.fieldChanged)
                ) {
                  await ElMessageBox.confirm(
                    `Please note, changes to account details such as Name and other details will move the status of your account to 'unverified'.${instance?.appContext.config.globalProperties.$filters.appName() } will need to verify your details before you can view and accepts shifts. This process can take up to 24 hours.`,
                    "Are you sure you want to change this?",
                    {
                      distinguishCancelAndClose: true,
                      showConfirmButton: !formsData[formName].disabled,
                      confirmButtonText: "Save Changes",
                      cancelButtonText: "Cancel",
                      confirmButtonClass: "el-button--green",
                      cancelButtonClass: "el-button--grey",
                      showClose: formsData[formName].disabled,
                    }
                  );
                  $store.dispatch("IDENTIFY_USER", {
                    name: formsData[formName].firstName.value,
                  });
                  console.log("IDENTIFY SUCCESFULLY");
                }
                const data = getFormData(formName);
                const mobileNumber = data.mobileNumber;
                const email = data.email;
                delete data.mobileNumber;
                delete data.email;

                // tranform community pharmacy form data
                const selectedEMMSoftware = data.EMMSoftware;
                const selectedCabinet = data.automatedDispenseryCabinet;

                data.customfields = {
                  hospital_pharmacy_1_additional_info: [{
                    values: selectedEMMSoftware.map((item) => {
                      return {
                        value: item,
                      };
                    }),
                    key: pharmacyAdditionalInfo?.hospitalPharmacy1AdditionalInfo[0]?.key,
                    field_type: pharmacyAdditionalInfo?.hospitalPharmacy1AdditionalInfo[0]?.fieldType,
                  }],
                  hospital_pharmacy_2_additional_info: [{
                    values: [{
                        value: selectedCabinet ? selectedCabinet : "",
                    }],
                    key: pharmacyAdditionalInfo?.hospitalPharmacy2AdditionalInfo[0]?.key,
                    field_type: pharmacyAdditionalInfo?.hospitalPharmacy2AdditionalInfo[0]?.fieldType,
                  }]
                };
                delete data.roboticDispensingSystem;
                delete data.hasRoboticDispensingSystem_other;
  
                let requests = [];
                requests.push($store.dispatch("SAVE_USER_DATA", data));
                let mobileNumberChanged = false;
                let emailChanged = false;
                console.log("FORM DATA:", formsData[formName]);
                if (
                  formsData[formName].mobileNumber &&
                  formsData[formName].mobileNumber.fieldChanged
                ) {
                  mobileNumberChanged = true;
                  requests.push(
                    $store.dispatch("UPDATE_USER_PHONE", {
                      phone: mobileNumber,
                    })
                  );
                }
  
                if (
                  formsData[formName].email &&
                  formsData[formName].email.fieldChanged
                ) {
                  emailChanged = true;
                  requests.push($store.dispatch("IDENTIFY_USER", { email }));
                  requests.push(
                    $store.dispatch("UPDATE_USER_EMAIL", {
                      email: email,
                    })
                  );
                }
  
                await Promise.all(requests);
  
                if (mobileNumberChanged) {
                  $store.dispatch("setVerifyPageData", {
                    mobileNumber: mobileNumber,
                  });
                }
  
                if (emailChanged) {
                  $store.dispatch("setVerifyPageData", {
                    email: email,
                  });
                }
  
                copyFormResetValue("userForm", true);
                goBack();
              } catch (errors) {
                $store.dispatch("clearVerifyPageData", {
                  mobileNumber: null,
                  email: null,
                });
                for (let key in errors) {
                  setFieldError(formName, key, errors[key]);
                  // }
                  // setFieldError('userForm', 'password', error.message);
                }
                checkFormValidation(formName, true);
                nextTick(() => {
                  setFormValidation(formName, "mobileNumber", true);
                });
              }
            })();
          } else {
            setFormValidation(formName, false, false);
            console.log("error submit!!");
            return false;
          }
        });
      };
  
      onBeforeRouteLeave((to, from, next) => {
        (async () => {
          try {
            let leave = await checkFormChanged("userForm");
            if (leave == "save") {
              await save("userForm");
            } else if (!leave) {
              next(false);
            } else {
              next();
            }
          } catch (error) {
            next(false);
            console.log(error);
          }
        })();
      });
  
      onMounted(() => {
        console.log('form data', formsData);
        setPageClassGlobal("global_profile_page");
        setFormRefs();
        formsData.userForm.address.ref.update(
          formsData.userForm.address.value.text
        );
        
  
        const scrollSection = $router.currentRoute.value.query.scroll;
  
        if (scrollSection) {
          setTimeout(() => {
            nextTick(() => {
              const sectionElement = document.getElementById(scrollSection);
              console.log("scroll out", sectionElement);
              if (sectionElement) {
                console.log("scroll out", sectionElement);
                sectionElement.scrollIntoView({ behavior: "smooth" });
              } else {
                console.log(`Element with ID '${scrollSection}' not found.`);
              }
            });
          }, 100);
        } else {
          console.log(
            "No scroll section specified in the route query parameters."
          );
        }
        checkFormValidation("userForm", true);
      });
  
      const {
        ["onFormMaskAccept"]: onFormMaskAccept,
        checkFormValidation,
        setFormValidation,
        copyFormResetValue,
        checkFormChanged,
        setFieldError,
        getFormValues, // eslint-disable-line no-unused-vars
        setFormRefs,
        formsData,
        formsRefs,
      } = formHooks(formsDataArray);
      const links = {      
        changeProfile: () => {
          $router.push({
            name: "profile_edit",
          });
        },
        changePhoto: () => {
          $router.push({
            name: "profile_photo",
          });
        },
        goToCovidCert: () => {
          $router.push({
            name: "profile_covid_cert",
          });
        },
        goToPersonalCovidCert: () => {
          $router.push({
            name: "profile_personal_cert",
          });
        },
        goToPayment: () => {
          $router.push({
            name: "profile_payment",
          });
        },
        goToEmergencyContact: () => {
          $router.push({
            name: "emergency_contact",
          });
        },
        goToPayout: () => {
          $router.push({
            name: "profile_payout",
          });
        },
        goToAhpra: () => {
          $router.push({
            name: "profile_ahpra",
          });
        },
        notifications: () => {
          $router.push({
            name: "profile_notifications",
          });
        },
        gallery: () => {
          $router.push({
            name: "profile_gallery",
          });
        },
        goToGst: () => {
          $router.push({
            name: "profile_gst",
          });
        },
        travel: () => {
          $router.push({
            name: "profile_travel",
          });
        },
  
        languages: () => {
          $router.push({
            name: "profile_languages",
          });
        },
  
        goToSupport: () => {
          $router.push({
            name: "support",
          });
        },
        goToAbout: () => {
          $router.push({
            name: "about",
          });
        },
        goToTermsAndConditions: () => {
          $router.push({
            name: "terms_and_conditions",
          });
        },
        goToPrivacyPolicy: () => {
          $router.push({
            name: "privacy_policy",
          });
        },
        changePassword: async () => {
          await $store.dispatch("PASSWORD_RESET");
          $router.push({
            name: "password_change",
          });
        },
        logout: () => {
          $store.dispatch("AUTH_LOGOUT");
        },
        accountDeletionRequest: () => {
          $router.push({
            name: "account_deletion",
          });
        },
        preferences: () => {
          $router.push({
            name: "preferences",
          });
        },
        nabp: () => {
          $router.push({
            name: "profile_nabp",
          });
        },
        licenseNumber:()=>{
          $router.push({
            name: "profile_license",
          });
        },
        taxAndPayment:()=>{
          $router.push({
            name: "profile_tax_and_payments",
          });
        },
        healthPlanBenefits:()=>{
          $router.push({
            name: "profile_health_plan_and_benefits",
          });
        },
        bankDetails:()=>{
          $router.push({
            name: "profile_tax_payments_bank_details",
          });
        },
        identityDocuments:()=>{
          $router.push({
            name: "profile_identity_document",
          });
        },
        softwareExperience:()=>{
          $router.push({
            name: "profile_software_experience",
          });
        },
        pharmacyExperience:()=>{
          $router.push({
            name: "profile_pharmacy_certification",
          });
        },
        proofOfInsurance:()=>{
          $router.push({
            name: "profile_proof_of_insurance",
          });
        },
        cv: () => {
            $router.push({
                name: "profile_cv",
            });
        },    
  
      };
      const shopLabel = computed(() => {
            if (isAustralia.value) return 'Shop Number';
            if (isUS.value) return 'Unit Number';
            return 'Unit Number'; // Default
        });
  
      return {
       
        formsData,
        onFormMaskAccept,
        checkFormValidation,
        goBack,
        save,
        userData,
        userRole,
        setAddressData,
        setAddress,
        onPhoneInput,
        onPhoneInput1,
        links,
        dateConvert,
        isAustralia,
        isUS,
        countryArray,
        isHealthPlanEnabled,
        pharmacyAdditionalInfo,
        shopLabel
      };
    },
  };
  </script>
  